import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import Logo from './Logo';
import { BRANCHES, NAV_LINKS } from '../data/mock';

export default function Footer() {
  return (
    <footer className="bg-[#2a1612] text-white/85 mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo light size={48} showTagline={true} />
          <p className="text-sm text-white/60 mt-5 leading-relaxed">
            60 years of disciplined, board-aligned coaching for ICSE, CBSE & ISC students from Class 5–12, across Behala and Howrah.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-amber-300 font-semibold mb-4">Quick Links</div>
          <ul className="space-y-2.5 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-amber-300 smooth">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-amber-300 font-semibold mb-4">Branches</div>
          <ul className="space-y-4 text-sm">
            {BRANCHES.map((b) => (
              <li key={b.name} className="flex gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-amber-300 shrink-0" />
                <div>
                  <div className="font-semibold text-white">{b.name}</div>
                  <div className="text-white/60 leading-relaxed">{b.address}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-amber-300 font-semibold mb-4">Get in touch</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-amber-300" /><a href="tel:+919903248390" className="hover:text-amber-300">99032-48390</a></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-amber-300" /><a href="tel:+919748881508" className="hover:text-amber-300">97488-81508</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-amber-300" /><a href="mailto:contact@rnacademy.org" className="hover:text-amber-300">contact@rnacademy.org</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} RN Academy. Trusted since 1965.</div>
          <div className="flex gap-5"><span>Behala · Kolkata</span><span>Howrah</span><span>West Bengal</span></div>
        </div>
      </div>
    </footer>
  );
}
